import { SerializedConstructor } from '@langchain/core/load/serializable';

import type { UnknownSerializedConstructor } from '@/types/schema';
import { parseLangSmithParamsFromRun } from '@/utils/langsmith-params';

import type { ManifestPreviewProps } from '../../Manifest.utils';
import { serializedModelNameEquals } from './utils';

export function useChatFireworksModelAndProvider(
  props: ManifestPreviewProps<UnknownSerializedConstructor>
) {
  const id = props.value.id.at(-1) ?? '';
  const kwargs = props.value.kwargs;
  const model = (kwargs.model ?? null) as string | null;

  const modelLabel = model?.startsWith('accounts/fireworks/models/')
    ? model.split('/').at(-1)
    : model;
  return {
    provider: id ?? null,
    model: modelLabel ?? null,
  };
}

export function inferChatFireworksManifestFromRun(
  params: ReturnType<typeof parseLangSmithParamsFromRun> | null,
  serializedModel: SerializedConstructor | null
): SerializedConstructor | null {
  if (
    !serializedModelNameEquals(serializedModel, 'ChatFireworks') ||
    // bug in LangChain JS means for some older runs params.ls_provider is set to 'openai'.
    !(
      params?.ls_provider === 'fireworks' || params?.ls_provider === 'openai'
    ) ||
    !(params?.ls_model_type == null || params.ls_model_type === 'chat')
  ) {
    return null;
  }

  return {
    lc: 1,
    type: 'constructor',
    id: ['langchain', 'chat_models', 'fireworks', 'ChatFireworks'],
    kwargs: {
      ...(params?.ls_model_name !== undefined && {
        model_name: params.ls_model_name,
      }),
      ...(params?.ls_temperature !== undefined && {
        temperature: params.ls_temperature,
      }),
      ...(params?.ls_max_tokens !== undefined && {
        max_tokens: params.ls_max_tokens,
      }),
    },
  };
}
